import { render, staticRenderFns } from "./Intervention.vue?vue&type=template&id=40f52faf&scoped=true&"
import script from "./Intervention.vue?vue&type=script&lang=js&"
export * from "./Intervention.vue?vue&type=script&lang=js&"
import style0 from "./Intervention.vue?vue&type=style&index=0&id=40f52faf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f52faf",
  null
  
)

export default component.exports